import { Text } from '../Text'
import { cn } from '@lib/cn'
import { NextPage } from 'next'
import React from 'react'

type LabelProps = {
  children: React.ReactNode
  hasError?: boolean
}

const Label: NextPage<LabelProps> = ({ children, hasError }) => {
  return (
    <Text
      as="label"
      variant="legend14"
      className={cn(
        'pointer-events-none absolute left-0 top-7 text-rolexBrown opacity-50 transition-all duration-200',
        hasError && 'text-rolexRed opacity-100',
      )}
    >
      {children}
    </Text>
  )
}

export default Label
